import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LoanBreakdownResponse } from 'api/ApplicationDataApi';
import { getLoanBreakdown } from 'thunks';

export interface LoanBreakdownState {
  isLoading: boolean;
  breakdowns: LoanBreakdownResponse;
  error?: boolean;
}

export const initialState: LoanBreakdownState = {
  isLoading: false,
  breakdowns: [],
};

const loanBreakdown = createSlice({
  name: 'loanBreakdown',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getLoanBreakdown.pending, (state) => {
      state.isLoading = true;
      state.error = false;
    });
    builder.addCase(getLoanBreakdown.fulfilled, (state, { payload }: PayloadAction<LoanBreakdownResponse>) => {
      state.breakdowns = payload ?? [];
      state.isLoading = false;
      state.error = false;
    });
    builder.addCase(getLoanBreakdown.rejected, (state) => {
      state.isLoading = false;
      state.error = true;
    });
  },
});

export default loanBreakdown.reducer;
